// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// <graphServiceSnippet>
import { Injectable } from '@angular/core';
import { Client } from '@microsoft/microsoft-graph-client';

import { AuthService } from './auth.service';
import { Event } from '../Ms Grapgh API files/event';

@Injectable()
export class GraphService {

  private graphClient: Client;
  constructor(
    private authService: AuthService) {

    // Initialize the Graph client
    this.graphClient = Client.init({
      authProvider: async (done) => {
        // Get the token from the auth service
        let token = await this.authService.getAccessToken()
          .catch((reason) => {
            done(reason, null);
          });

        if (token)
        {
          done(null, token);
        } else {
          done("Could not get an access token", null);
        }
      }
    });
  }

  async getEvents(): Promise<Event[]> {
    try {
      let result =  await this.graphClient
        .api('/me/events')
        .select('subject,organizer,start,end')
        .orderby('createdDateTime DESC')
        .get();

      return result.value;
    } catch (error) {
      console.log('Could not get events', JSON.stringify(error, null, 2));
    }
  }

  
  async getContacts(): Promise<any[]> {
    try {
      let result =  await this.graphClient
        .api('/me/contacts')
        .select('emailAddresses,givenName')
        .get();

      return result.value;
    } catch (error) {
      console.log('Could not get contacts', JSON.stringify(error, null, 2));
    }
  }
}
